import { render, staticRenderFns } from "./SubCardFila.vue?vue&type=template&id=5f51643b&"
import script from "./SubCardFila.vue?vue&type=script&lang=js&"
export * from "./SubCardFila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports